import type {ReactElement} from 'react';
import {Button, ButtonSize, ButtonType} from '@Components/button';
import {Text, TextSize} from '@Components/text';
import type {DesignSelectionSummaryBarProps} from './design-selection-summary-bar.types';
import styles from './design-selection-summary-bar.module.scss';

export function DesignSelectionSummaryBar({selectedDesignCount, onDeselectAll}: DesignSelectionSummaryBarProps): ReactElement | null {
  if (selectedDesignCount === 0) {
    return null;
  }

  const deselectCtaText = selectedDesignCount === 1 ? window.i18next.t('pmwjs_deselect') : window.i18next.t('pmwjs_deselect_all');

  return (
    <div className={styles.selectionSummaryBar}>
      <Text size={TextSize.MD} bold val={window.i18next.t('pmwjs_x_designs_selected', {count: selectedDesignCount})} className={styles.selectionSummaryBarCount} />
      <Button type={ButtonType.SECONDARY} onDark size={ButtonSize.MEDIUM} text={deselectCtaText} onClick={onDeselectAll} />
    </div>
  );
}
